import { AGRAVOS, DESCRICAO_AGRAVOS, type Agravo } from '@metaepi/shared';
import { useParams } from 'react-router';
import { ExigirPermissao } from '../../app/Guardas';
import { PaginaHiv } from '../agravos/PaginaHiv';
import { PaginaSifilis } from '../agravos/PaginaSifilis';
import { useSessao } from '../auth/contexto';
import { EmConstrucao, EmDesenvolvimento, NaoEncontrada } from './Paginas';

/** /agravos/:agravo — páginas de Sífilis e HIV (D-060); os demais "Em desenvolvimento" (D-014). */
export function PaginaAgravo() {
  const { agravo } = useParams();
  const { conta } = useSessao();
  if (!AGRAVOS.includes(agravo as Agravo)) return <NaoEncontrada />;
  const descricao = DESCRICAO_AGRAVOS[agravo as Agravo];
  // Disponibilidade vem da API (o superadmin libera em "Módulos disponíveis")
  const disponivel = conta?.agravosDisponiveis[agravo as Agravo] ?? descricao.disponivel;
  if (!disponivel) return <EmDesenvolvimento titulo={descricao.rotulo} />;
  if (agravo === 'sifilis' || agravo === 'hiv') {
    return (
      <ExigirPermissao permissao="agravos:ver">
        {agravo === 'sifilis' ? <PaginaSifilis /> : <PaginaHiv />}
      </ExigirPermissao>
    );
  }
  return (
    <EmConstrucao
      titulo={descricao.rotulo}
      modulo={4}
      descricao="Fluxo guiado por protocolo, do pré-natal ao seguimento da criança exposta."
    />
  );
}
